import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentLessonItem } from '../../models/parent-learning.types';

@Component({
  selector: 'app-parent-learn-lesson-list',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './parent-learn-lesson-list.component.html',
  styleUrl: './parent-learn-lesson-list.component.scss',
})
export class ParentLearnLessonListComponent {
  lessons = input<ParentLessonItem[]>([]);
  selectedLessonId = input<string | null>(null);
  disabled = input(false);
  /** Lesson id that just unlocked (drives highlight animation) */
  newlyUnlockedId = input<string | null>(null);

  lessonSelect = output<string>();

  readonly sortedLessons = computed(() =>
    [...this.lessons()].sort(
      (a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0),
    ),
  );

  onLessonClick(lesson: ParentLessonItem): void {
    if (this.disabled() || lesson.isLocked) {
      return;
    }
    this.lessonSelect.emit(lesson.id);
  }

  lessonStatus(lesson: ParentLessonItem): 'locked' | 'done' | 'active' | 'ready' {
    if (lesson.isLocked) {
      return 'locked';
    }
    if (lesson.isCompleted) {
      return 'done';
    }
    if (lesson.id === this.selectedLessonId()) {
      return 'active';
    }
    return 'ready';
  }
}
